module.exports = __webpack_public_path__ + "static/media/medal.bd896321.svg";